<app-table [table]="rapidoAccountInfoTable" (showCUSelectors)="showCUSelectors()" (showChips)="showChips($event)"></app-table>
